module.exports = __webpack_public_path__ + "img/jiangyin_s.65b115c.png";